// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"09074fc3","471":"b802fd63","571":"628e1f1f","636":"584c264e"}[chunkId] + ".chunk.css";
};